import { Box } from 'components/Box';
import { CallToActionButton, PrimaryButtonRouterLink } from 'components/Button';
import { BodySmall } from 'components/Text/BodySmall';
import { H4 } from 'components/Text/H4';
import { HeadingSmall } from 'components/Text/HeadingSmall';
import { CmsApiStickyHeaderLinksBlockData } from 'modules/cms/api/types/blocks/CmsApiStickyHeaderLinksBlock';
import { useCurrentUserHasGradProgram, useIsLoggedIn } from 'modules/cms/hooks';
import { colors, gutterWidth } from 'theme/theme';

type Data = CmsApiStickyHeaderLinksBlockData & {
  isGrad?: boolean;
};

type Props = {
  data: Data;
};

export function CmsAmpLinksBlock({
  data: { links, buttonText, buttonUrl, isGrad },
}: Props) {
  const loggedIn = useIsLoggedIn();
  const hasGradProgram = useCurrentUserHasGradProgram();
  const hasButton = buttonUrl && buttonText;

  return (
    <Box
      p={gutterWidth / 2}
      mx={[-gutterWidth / 2, null, -gutterWidth]}
      justifyContent="center"
      borderRadius={[0, 0, 0, 10]}
      bg={colors.backgroundGrey}
      textAlign="center"
    >
      <HeadingSmall>On this page</HeadingSmall>
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        my={-gutterWidth / 2}
      >
        {links.map((link) => (
          <Box
            minWidth={160}
            maxWidth={240}
            width={1 / links.length}
            px={gutterWidth / 2}
            my={gutterWidth / 2}
            key={link.url}
          >
            <Box
              component="a"
              href={`#content-anchor-${link.url}`}
              textDecoration="none"
            >
              <H4 mb="0.375em" lineHeight={1.375}>
                {link.heading}
              </H4>
              {link.subHeading && (
                <BodySmall lineHeight={1.375}>{link.subHeading}</BodySmall>
              )}
            </Box>
          </Box>
        ))}
      </Box>

      {hasButton ? (
        <Box
          mt={gutterWidth / 2}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <PrimaryButtonRouterLink to={buttonUrl}>
            {buttonText}
          </PrimaryButtonRouterLink>
        </Box>
      ) : (
        isGrad && (
          <Box
            mt={gutterWidth / 2}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            <CallToActionButton
              loggedIn={loggedIn}
              hasGradProgram={hasGradProgram}
            />
          </Box>
        )
      )}
    </Box>
  );
}
